import { SmartLabel } from "../types/mail";

/**
 * Label SmartLabel effectif d'un mail : la liste à laquelle il appartient réellement.
 *
 * `isUserProcessed` est PRIORITAIRE sur le label d'analyse — un mail traité vit dans « Traités » quel
 * que soit son `smartLabel`. C'est le miroir exact de la requête backend
 * (`smartLabel.repository.ts` : `Traites` = `isUserProcessed = true` sans filtre sur `smartLabel`,
 * les autres labels = `smartLabel = X AND isUserProcessed = false`).
 *
 * Source unique de la règle : elle pilotait à la fois le placement dans le store
 * (`CustomViewManager._updateSmartLabelEntryAndSendEvent`) et le contrôle d'appartenance à l'affichage
 * (`MailManager.fetchCustomViewMails`). Deux copies divergentes auraient rangé un même mail dans deux
 * listes différentes selon le chemin — d'où cette fonction, appelée par les deux.
 *
 * @returns `undefined` si le mail n'a pas de label exploitable : mail non qualifié (jamais analysé) ou
 *          copie dont `smartLabel` a été effacé (`_updateRecordWithoutAnalysis`, passage en corbeille).
 */
export function effectiveSmartLabel(mail: {
    isUserProcessed?: boolean;
    smartLabel?: SmartLabel;
}): SmartLabel | undefined {
    return mail.isUserProcessed ? SmartLabel.Traites : mail.smartLabel;
}
